// extracted by mini-css-extract-plugin
module.exports = {"container":"_46dfb2","title":"_3cc061","description":"b4cb40","cancelButton":"a70f02","reviewNotificationsButton":"_23696a"};